// Use the same empty values for survey and inbox summary figures.
export const PERFORMANCE_METRIC_DEFAULTS = Object.freeze({
  value: 0,
  percentage: 0,
});

export const performanceConstants = {
  ALL_BRAND_RESPONSE_DATA: "ALL_BRAND_RESPONSE_DATA",
  CUSTOMER_RESPONSES_EXPORT_ALL_DATA: "CUSTOMER_RESPONSES_EXPORT_ALL_DATA",
  ALL_BRAND_PARTICIPATION_RESPONSE_DATA:
    "ALL_BRAND_PARTICIPATION_RESPONSE_DATA",
  ALL_BRAND_CONVERSION_RESPONSE_DATA: "ALL_BRAND_CONVERSION_RESPONSE_DATA",
  SURVEY_CONVERSION_RATE_KPI_SUMMARY_DATA:
    "SURVEY_CONVERSION_RATE_KPI_SUMMARY_DATA",
  GET_ALL_BRANDS_CONVERSION_RESPONSES_FOR_EXPORT:
    "GET_ALL_BRANDS_CONVERSION_RESPONSES_FOR_EXPORT ",
  GOOGLE_REVIEW: "googleReview",
  GET_INBOX_CONVERSATION_DATA: "GET_INBOX_CONVERSATION_DATA",
  GET_INBOX_CONVERSATION_DATA_EXPORT: "GET_INBOX_CONVERSATION_DATA_EXPORT",
  GET_INBOX_CONVERSATION_SUMMARY_DATA: "GET_INBOX_CONVERSATION_SUMMARY_DATA",
  GET_INBOX_CONVERSATION_DATA_BY_BRAND_ID:
    "GET_INBOX_CONVERSATION_DATA_BY_BRAND_ID",
};

export const tabsName = {
  starRating: "Star Rating",
  conversionRate: "Conversion Rate",
  inboxConversationTab: "Inbox Report",
};

export const starRatingConstants = {
  minStarRatingVal: "0",
  maxStarRatingVal: "5",
};

export const starRatingExportHeaders = [
  { label: "BRAND NAME", key: "name" },
  { label: "TOTAL RESPONSES", key: "recordCount" },
  { label: "GUEST RATING", key: "averageGuestRatings" },
  { label: "PREVIOUS", key: "previousGuestRatings" },
  { label: "CHANGE", key: "change" },
];

export const participationExportHeaders = [
  { label: "BRAND NAME", key: "name" },
  { label: "ORDERS PLACED", key: "ordersPlaced" },
  { label: "SURVEYS COMPLETED", key: "surveysCompleted" },
  { label: "PARTICIPATION RATE", key: "participation" },
  { label: "PREVIOUS", key: "previousParticipation" },
  { label: "CHANGE", key: "change" },
];

export const conversionRateExportHeaders = [
  { label: "Brand Name", key: "name" },
  { label: "Surveys Sent Value", key: "surveySentValue" },
  { label: "Surveys Sent Percentage", key: "surveySentPercentage" },
  { label: "Survey Opened Value", key: "surveyOpenedValue" },
  { label: "Survey Opened Percentage", key: "surveyOpenedPercentage" },
  { label: "Surveys Started Value", key: "surveyStartedValue" },
  { label: "Surveys Started Percentage", key: "surveyStartedPercentage" },
  { label: "Surveys Complete Value", key: "surveyCompleteValue" },
  { label: "Surveys Complete Percentage", key: "surveyCompletePercentage" },
  {
    label: "Positive Surveys Complete Value",
    key: "positiveSurveyCompleteValue",
  },
  {
    label: "Positive Surveys Complete Percentage",
    key: "positiveSurveyCompletePercentage",
  },
  {
    label: "Passive Surveys Complete Value",
    key: "passiveSurveyCompleteValue",
  },
  {
    label: "Passive Surveys Complete Percentage",
    key: "passiveSurveyCompletePercentage",
  },
  {
    label: "Negative Surveys Complete Value",
    key: "negativeSurveyCompleteValue",
  },
  {
    label: "Negative Surveys Complete Percentage",
    key: "negativeSurveyCompletePercentage",
  },
  { label: "Redirect to Google Review Value", key: "googleReviewValue" },
  {
    label: "Redirect to Google Review Percentage",
    key: "googleReviewPercentage",
  },
];

export const inboxConversationExportHeaders = [
  { label: "Brand Name", key: "brandName" },
  { label: "Total Conversations", key: "totalConversation" },
  { label: "Conversation (Not Started)", key: "conversationNotStarted" },
  { label: "Conversation (Started)", key: "conversationStarted" },
  { label: "Conversation Started Rate (%)", key: "conversationStartedRate" },
  { label: "Consumer (Did Not Responded)", key: "consumerNotResponded" },
  { label: "Consumer (Responded)", key: "consumerResponded" },
  { label: "Response Rate (%)", key: "consumerResponseRate" },
];

export const conversionRateTableColumnKeys = {
  BRAND_NAME: "name",
  SURVEY_SENT_COUNT: "surveySentCount",
  SURVEY_OPENED_COUNT: "surveyOpenedCount",
  SURVEY_STARTED_COUNT: "surveyStartedCount",
  SURVEY_COMPLETE_COUNT: "surveyCompleteCount",
  GOOGLE_REVIEW_COUNT: "googleReviewCount",
  RECEIVED_GOOGLE_LINK_COUNT: "receiveGoogleLinkCount",
  POSITIVE_SURVEY_COMPLETED_COUNT: "positiveSurveyCompleteCount",
  NEGATIVE_SURVEY_COMPLETED_COUNT: "negativeSurveyCompleteCount",
  PASSIVE_SURVEY_COMPLETED_COUNT: "passiveSurveyCompleteCount",
};

export const conversionRateTabFilterOptions = [
  {
    name: "Google Review",
    value: "googleReview",
  },
];

export const inboxConversationTabFilterOptions = [
  {
    name: "HungerRush",
    value: 1,
  },
  {
    name: "Menufy",
    value: 2,
  },
];

export const inboxReportTabConstants = {
  FROM: 0,
  TAKE: 15,
};

export const reportTypesConstants = {
  CONVERSION_REPORT: "conversionReport",
  INBOX_REPORT: "inboxReport",
};
